import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { PRE_ACTIVATION_ARIA_REQUIRED } from "../../../i18n/keysTranslations";

const RequiredAsterisk = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="span"
      sx={{
        color: "text.primary",
        marginLeft: "4px",
        fontWeight: 900,
        fontSize: "16px",
        verticalAlign: "middle",
      }}
      aria-label={t(PRE_ACTIVATION_ARIA_REQUIRED)}
    >
      *
    </Box>
  );
};

const FieldLabel = ({ text = "", htmlFor = "", required = false }) => {
  return (
    <Box
      component="label"
      htmlFor={htmlFor}
      sx={{
        display: "block",
        fontSize: "13px",
        fontWeight: 700,
        color: "text.primary",
        marginBottom: "2px",
      }}
    >
      {text}
      {required && <RequiredAsterisk />}
    </Box>
  );
};

export default FieldLabel;
